/**
 * Reprodução exclusiva de mídia — apenas um player (áudio OU vídeo) por vez,
 * padrão WhatsApp/Telegram. Chamar no evento 'play' de qualquer player de mídia.
 */
export const pauseOtherMedia = (current: HTMLMediaElement): void => {
  document.querySelectorAll<HTMLMediaElement>('audio, video').forEach((media) => {
    if (media !== current && !media.paused) {
      media.pause();
    }
  });
};
